export default "__VITE_PUBLIC_ASSET__14bad8fe__"